import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Upload, FileText, LogOut, LogIn, CheckCircle, Loader, ClipboardList } from "lucide-react";
import { useAuth } from "../context/AuthContext"; 
import "./Sidebar.css";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();
  const [showUploadDataSubMenu, setShowUploadDataSubMenu] = useState(false);
  const [showBankDataSubMenu, setShowBankDataSubMenu] = useState(false);
  const [showDebtDataSubMenu, setShowDebtDataSubMenu] = useState(false);
  const [showCheckDataSubMenu, setShowCheckDataSubMenu] = useState(false);
  const [showBookBankDataSubMenu, setShowBookBankDataSubMenu] = useState(false);
  const [showProcessDataSubMenu, setShowProcessDataSubMenu] = useState(false);
  const [showReportDataSubMenu, setShowReportDataSubMenu] = useState(false);
  const [showConfigDataSubMenu, setShowConfigDataSubMenu] = useState(false);
  const [showStatmentDataSubMenu, setShowStatmentDataSubMenu] = useState(false);

  // const [showKbankSubMenu, setShowKbankSubMenu] = useState(false);
  // const [showTtbSubMenu, setShowTtbSubMenu] = useState(false);
  const [activeBankSubMenu, setActiveBankSubMenu] = useState(null);

  const toggleBankSubMenu = (bankName) => {
    setActiveBankSubMenu((prev) => (prev === bankName ? null : bankName));
  };

  const sidebarRef = useRef(null);
   const closeAllSubMenus = () => {
    setShowUploadDataSubMenu(false);
    setShowBankDataSubMenu(false);
    setShowDebtDataSubMenu(false);    
    setShowCheckDataSubMenu(false);
    setShowBookBankDataSubMenu(false);
    setShowProcessDataSubMenu(false);
    setShowReportDataSubMenu(false);
    setShowConfigDataSubMenu(false);
    setShowStatmentDataSubMenu(false);

    // setShowKbankSubMenu(false); 
    // setShowTtbSubMenu(false);
    setActiveBankSubMenu(null);

  };

  const toggleSubMenu = (menu) => {
    closeAllSubMenus();
    switch (menu) {
      case "uploadData":
        setShowUploadDataSubMenu(!showUploadDataSubMenu);
        break;
      case "bankData":
        setShowBankDataSubMenu(!showBankDataSubMenu);
        break;
      case "debtData":
        setShowDebtDataSubMenu(!showDebtDataSubMenu);
        break;
      case "checkData":
        setShowCheckDataSubMenu(!showCheckDataSubMenu);
        break;
      case "bookbankData":
        setShowBookBankDataSubMenu(!showBookBankDataSubMenu);
        break;
      case "processData":
        setShowProcessDataSubMenu(!showProcessDataSubMenu);
        break;
      case "reportData":
        setShowReportDataSubMenu(!showReportDataSubMenu);
        break;
      case "configData":
        setShowConfigDataSubMenu(!showConfigDataSubMenu);
        break;  
      case "statmentData":
        setShowStatmentDataSubMenu(!showStatmentDataSubMenu);
        break;  

      // case "kbankSubMenu":
      //   setShowKbankSubMenu(!showKbankSubMenu);
      //   break;
      // case "ttbSubMenu":
      //   setShowTtbSubMenu(!showTtbSubMenu);
      //   break;

      default:
        break;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current && 
        !sidebarRef.current.contains(event.target) && 
        !event.target.closest(".submenu") && 
        !event.target.closest(".sidebar-overlay")
      ) {
        closeAllSubMenus(); 
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    closeAllSubMenus();
  }, [location]);

  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`} ref={sidebarRef}>
      <ul style={{ paddingBottom: '120px' }}>
        {!isAuthenticated ? (
          <li>
            <Link to="/login" onClick={toggleSidebar}>
              <LogIn size={16} /> Login
            </Link>
          </li>
        ) : (
          <>
            <li>
              <Link to="/home" onClick={toggleSidebar}>
                <Home size={16} /> หน้าหลัก
              </Link>
            </li>
            <li>
              <button onClick={() => toggleSubMenu("uploadData")} className="submenu-toggle">
                1.อัพโหลดข้อมูลหลัก
              </button>
              {showUploadDataSubMenu && (
                <ul className="submenu">
                  <li><Link to="/upload/overdraft" onClick={toggleSidebar}>1.1 เงินกู้เบิกเกินบัญชี(OD)</Link></li>
                  <li><Link to="/upload/sapmasterar" onClick={toggleSidebar}>1.2 ลูกหนี้ระบบ SAP(AR)</Link></li>
                  <li><Link to="/upload/sapmasterap" onClick={toggleSidebar}>1.3 เจ้าหนี้ระบบ SAP(AP)</Link></li>
                  <li><Link to="/upload/saparmap" onClick={toggleSidebar}>1.4 จับคู่ลูกหนี้(AR Mapping)</Link></li>
                  <li><Link to="/upload/sapapmap" onClick={toggleSidebar}>1.5 จับคู่เจ้าหนี้(AP Mapping)</Link></li>
                  <li><Link to="/upload/fapmasterar" onClick={toggleSidebar}>1.6 ลูกหนี้ระบบ FAP(AR)</Link></li>
                  <li><Link to="/upload/fapmasterap" onClick={toggleSidebar}>1.7 เจ้าหนี้ระบบ FAP(AP)</Link></li>
                  <li><Link to="/upload/bankaccount" onClick={toggleSidebar}>1.8 บัญชีธนาคาร(Account)</Link></li>
                </ul>
              )}
            </li>
            <li>
  <button onClick={() => toggleSubMenu("bankData")} className="submenu-toggle">
    2.อัพโหลดข้อมูลธนาคาร
  </button>
  {showBankDataSubMenu && (
    <ul className="submenu">
      <li><Link to="/upload/bank-bbl" onClick={toggleSidebar}>2.1 กรุงเทพ</Link></li>
      <li><Link to="/upload/bank-ktb" onClick={toggleSidebar}>2.2 กรุงไทย</Link></li>
      <li>
        <button 
          onClick={() => toggleBankSubMenu('kbank')} 
          className="submenu-toggle nested-toggle"
        >
          2.3 กสิกรไทย
        </button>
        {activeBankSubMenu === 'kbank' && (
          <ul className="submenu nested-submenu">
            <li>
              <Link to="/upload/bank-kbank" onClick={toggleSidebar}>2.3.1 Statement</Link>
            </li>
            <li>
              <Link to="/upload/bank-kbank-bill-payment" onClick={toggleSidebar}>2.3.2 Bill Payments</Link>
            </li>
          </ul>
        )}
      </li>
      <li><Link to="/upload/bank-scb" onClick={toggleSidebar}>2.4 ไทยพาณิชย์</Link></li>
      <li>
        <button 
          onClick={() => toggleBankSubMenu('ttb')} 
          className="submenu-toggle nested-toggle"
        >
          2.5 ทหารไทยธนชาต
        </button>
        {activeBankSubMenu === 'ttb' && (
          <ul className="submenu nested-submenu">
            <li>
              <Link to="/upload/bank-ttb" onClick={toggleSidebar}>2.5.1 Statement</Link>
            </li>
            <li>
              <Link to="/upload/bank-ttb-bill-payment" onClick={toggleSidebar}>2.5.2 Bill Payments</Link>
            </li>
          </ul>
        )}
      </li>
      <li><Link to="/upload/bank-bay" onClick={toggleSidebar}>2.6 กรุงศรีอยุธยา</Link></li>
      <li><Link to="/upload/bank-uob" onClick={toggleSidebar}>2.7 ยูโอบี</Link></li>                                       
    </ul>
  )}
</li>
            <li>
              <button onClick={() => toggleSubMenu("debtData")} className="submenu-toggle">
                3.อัพโหลดข้อมูล ERP
              </button>
              {showDebtDataSubMenu && (
                <ul className="submenu">
                  <li><Link to="/upload/debt-sappaymentreceive" onClick={toggleSidebar}>3.1 SAP แยกประเภทตามธนาคาร</Link></li>
                  <li><Link to="/upload/100034" onClick={toggleSidebar}>3.2 SAP อัตราแลกเปลี่ยน</Link></li>
                </ul>
              )}
            </li>
            <li>
              <button onClick={() => toggleSubMenu("checkData")} className="submenu-toggle">
                4.ตรวจสอบไฟล์อัพโหลด
              </button>
              {showCheckDataSubMenu && (
                <ul className="submenu">
                  <li><Link to="/check/master" onClick={toggleSidebar}>4.1 ไฟล์ข้อมูลหลัก</Link></li>                  
                  <li><Link to="/check/bank" onClick={toggleSidebar}>4.2 ไฟล์ข้อมูลธนาคาร</Link></li>
                  <li><Link to="/check/debt" onClick={toggleSidebar}>4.3 ไฟล์ข้อมูล ERP</Link></li>
                </ul>
              )}
            </li>
            <li>
              <button onClick={() => toggleSubMenu("bookbankData")} className="submenu-toggle">
                5.สมุดบัญชีธนาคาร
              </button>
              {showBookBankDataSubMenu && (
                <ul className="submenu">
                  <li><Link to="/bookbank/fill" onClick={toggleSidebar}>5.1 กรอกรายการ</Link></li>
                   <li><Link to="/bookbank/display" onClick={toggleSidebar}>5.2 ตรวจสอบข้อมูล</Link></li>
                </ul>
              )}
            </li>
            <li>
              <button onClick={() => toggleSubMenu("statmentData")} className="submenu-toggle">
                6.รีวิวข้อมูลธนาคาร
              </button>
              {showStatmentDataSubMenu && (
                <ul className="submenu">
                  <li><Link to="/review/statement" onClick={toggleSidebar}>6.1 ระบุข้อมูลรายการ</Link></li>
                  <li><Link to="/review/statement-unknown" onClick={toggleSidebar}>6.2 เงินไม่ทราบที่มา</Link></li>
                </ul>
              )}
            </li>
            <li>
              <button onClick={() => toggleSubMenu("processData")} className="submenu-toggle">
                7.กระทบยอดข้อมูล
              </button>
              {showProcessDataSubMenu && (
                <ul className="submenu">
                  <li><Link to="/process/reconcile" onClick={toggleSidebar}>7.1 รันกระทบยอด</Link></li>
                </ul>
              )}
            </li>
            <li>
              <button onClick={() => toggleSubMenu("reportData")} className="submenu-toggle">
                8.รายงาน
              </button>
              {showReportDataSubMenu && (
                <ul className="submenu">
                  <li><Link to="/080001" onClick={toggleSidebar}>8.1 ภาพรวมกระแสเงินสด</Link></li>
                  <li><Link to="/080010" onClick={toggleSidebar}>8.2 เงินสดทุกธนาคารรายวัน</Link></li>
                  <li><Link to="/080002" onClick={toggleSidebar}>8.3 เงินสดแยกตามธนาคาร</Link></li>
                  <li><Link to="/080003" onClick={toggleSidebar}>8.4 รายการเดินบัญชี</Link></li>
                  <li><Link to="/080004" onClick={toggleSidebar}>8.5 เงินไม่ทราบที่มา</Link></li>
                  <li><Link to="/080005" onClick={toggleSidebar}>8.6 ค่าธรรมเนียม</Link></li>
                  <li><Link to="/080006" onClick={toggleSidebar}>8.7 โอนเงินภายในบริษัท</Link></li>
                  <li><Link to="/080007" onClick={toggleSidebar}>8.8 เงินต้นและดอกเบี้ย</Link></li>
                  <li><Link to="/080008" onClick={toggleSidebar}>8.9 โอนเงินของผู้บริหาร</Link></li>
                  <li><Link to="/080009" onClick={toggleSidebar}>8.10 กระทบยอดธนาคาร</Link></li>
                  <li><Link to="/080011" onClick={toggleSidebar}>8.11 เงินสดคงเหลือทุกธนาคาร</Link></li>
                </ul>
              )}
            </li>

            <li className="menu-separator" aria-hidden="true"></li>

            <li>
              <button
                className="logout-menu-item"
                onClick={() => {
                  logout();
                  toggleSidebar();
                }}
              >
                <LogOut size={16} />
                <span style={{ marginLeft: 8 }}>Logout</span>
              </button>
            </li>
         
          </>
        )}
      </ul>

      {/* {isAuthenticated && (
        <div className="logout" onClick={() => { logout(); toggleSidebar(); }}>
          <LogOut size={16} />
          <span>Logout</span>
        </div>
      )} */}
    </div>
  );
};

export default Sidebar;
